import {API} from '../../api/API';
import { LOGIN_URL} from '../../config/config';


export const login = (loginInputData, loginSuccessFunction, loginFailureFunction) => {  
    API.post(LOGIN_URL, loginInputData)
        .then(res => {
            loginSuccessFunction(res.data)
        })
        .catch(err => {
            loginFailureFunction(err.response.data);
            
        });
}